// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3YCVW","rightAdornment":"Header_rightAdornment__3GkQQ"};